






























import { RoomNumbersWithPatientPhotos } from '@/constants/patient-photos'
import { getInRoomLabel, getMapLocationEventColor } from '@/utils/patients'
import { readableTimeSince } from '@/utils/time'
export default {
  name: 'ResidentStatCard',

  props: {
    patient: {
      type: Object,
      required: true,
    },
    detailedPatient: {
      type: Object,
      required: true,
    },
    patientWithLatestVisit: {
      type: Object,
      required: true,
    },
  },
  computed: {
    currentLocation() {
      return getInRoomLabel(this.patient).toUpperCase() //isInOwnRoom(this.patient) ? 'IN ROOM' : 'OUT OF ROOM'
    },
    currentLocationColor() {
      return getMapLocationEventColor(this.patient)
    },
    currentRoomName() {
      if (this.patient.lastLocationName) {
        return this.patient.lastLocationName
      }
      return this.pronoun() + ' room'
    },
    lastSeenInRoomTime() {
      if (!this.patient.lastTrackerConnectionTimestamp) {
        return 'No recent data from resident'
      }
      let timeStr = readableTimeSince({ timestamp: this.patient.lastTrackerConnectionTimestamp })
      return 'Resident was last seen in ' + this.currentRoomName + ' <b>' + timeStr + '</b>'
    },
    latestVisitedTime() {
      if (!this.patientWithLatestVisit || !this.patientWithLatestVisit.visitTimestamp) {
        return 'No recent staff visit'
      }
      let timeStr = readableTimeSince({ timestamp: this.patientWithLatestVisit.visitTimestamp })
      let staff = this.patientWithLatestVisit.staffFirstName + ' ' + this.patientWithLatestVisit.staffLastName
      return 'Last visited <b>' + timeStr + '</b> by ' + staff
    },
    hasPatientPhoto() {
      return RoomNumbersWithPatientPhotos.includes(this.patient.roomNumber) ? true : false
    },
  },
  methods: {
    pronoun() {
      let lower = (this.detailedPatient.sex || '').toLowerCase()
      switch (lower) {
        case 'male':
          return 'his'
        case 'female':
          return 'her'
      }
      return 'their'
    },
  },
}
